// extracted by mini-css-extract-plugin
export var main = "textarea-module--main--3218b";